import { type Filter, type InferFilterItemFromFilter, OperatorType } from '@adv-frontend/filters';
import { OPERATOR_VALUES_MAP } from './constants';

type BackendFilterOperator = Exclude<keyof typeof OperatorType, 'Like' | 'NotLike'>;

const convertOperatorForBackend = (operator: OperatorType = OperatorType.Eq): BackendFilterOperator => {
    const backendOperator = OPERATOR_VALUES_MAP[operator];

    if (backendOperator === 'Like' || backendOperator === 'NotLike') {
        throw new Error(`Unsupported backend filter operator: ${backendOperator}`);
    }

    return backendOperator;
};

export const convertDynamicFiltersForBackend = <F extends Filter<string, string | string[]>>(
    filterItems: InferFilterItemFromFilter<F>[]
) =>
    filterItems
        .filter(({ value }) => value.length > 0)
        .map(({ filterId, operator, value }) => {
            const backendOperator = convertOperatorForBackend(operator);

            if (Array.isArray(value)) {
                return {
                    field: filterId,
                    operator: backendOperator,
                    values: value,
                };
            }

            return {
                field: filterId,
                operator: backendOperator,
                value,
            };
        });
